var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartnerMedallionLg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 111.119,
    height: 157.965,
    viewBox: "0 0 111.119 157.965",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31923",
    "data-name": "Rectangle 31923",
    width: 111.119,
    height: 157.965,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40664",
    "data-name": "Path 40664",
    d: "M87.73,175.8a55.512,55.512,0,0,0,82.607-74.179A56.751,56.751,0,0,0,166.2,97.47L87.73,175.811Z",
    transform: "translate(-87.73 -97.47)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40665",
    "data-name": "Path 40665",
    d: "M86.45,139.552c0,24.921,19.734,45.122,44.059,45.122s44.059-20.2,44.059-45.122S154.833,94.43,130.509,94.43s-44.059,20.2-44.059,45.122",
    transform: "translate(-86.45 -94.43)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Partner-medallion",
    transform: "translate(0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Platinum_Partner_medallion_small",
    transform: "translate(-0.001 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15117",
    d: "M127.982,50.26,106.77,90.649h31.339L159.568,50.26H128Z",
    transform: "translate(-67.781 -50.26)",
    fill: "#b0b0af"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12265",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14172",
    "data-name": "Group 14172",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12264",
    transform: "translate(0 35.164)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15118",
    d: "M148.548,77.38h-4.655a1.464,1.464,0,0,0-1.465,1.465h0v3.54a2.236,2.236,0,0,1-2.243,2.243H113.073a2.236,2.236,0,0,1-2.243-2.243h0v-3.54a1.464,1.464,0,0,0-1.465-1.465h-5.044a1.447,1.447,0,0,0-1.4,1.037L96.36,99.656h60.175l-6.561-21.238a1.475,1.475,0,0,0-1.4-1.037",
    transform: "translate(-70.869 -77.38)",
    fill: "#999898"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15119",
    d: "M132.259,86.44A55.562,55.562,0,0,0,90.989,179.2l78.47-78.47a55.3,55.3,0,0,0-37.2-14.288",
    transform: "translate(-76.7 -74.693)",
    fill: "#cecdcc"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12267",
    transform: "translate(14.302 61.213)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14173",
    "data-name": "Group 14173",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12266",
    transform: "translate(0 -0.013)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4149",
    width: 103.106,
    height: 103.041,
    fill: "#d3d3d3"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12269",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14174",
    "data-name": "Group 14174",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12268",
    transform: "translate(10.373 57.271)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15121",
    d: "M129.9,94.43a45.122,45.122,0,1,1-45.2,45.122A45.121,45.121,0,0,1,129.9,94.43h0",
    transform: "translate(-84.7 -94.43)",
    fill: "#999898"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12271",
    transform: "translate(12.642 57.271)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14175",
    "data-name": "Group 14175",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12270",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4151",
    width: 88.13,
    height: 90.243,
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12273",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14176",
    "data-name": "Group 14176",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12272",
    transform: "translate(15.002 0.078)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15123",
    d: "M144.75,90.631H113.411L88.27,50.32H120.1Z",
    transform: "translate(-88.27 -50.32)",
    fill: "#57a932"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_40666",
    "data-name": "Path 40666",
    d: "M125.762,160.963,112.2,137.481,98.65,114h54.224l-13.562,23.481-13.55,23.481Z",
    transform: "translate(-70.191 -31.355)",
    fill: "#489835"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40667",
    "data-name": "Path 40667",
    d: "M125.569,158.03,113.2,136.61l-12.37-21.42H150.3l-12.37,21.42-12.357,21.42Z",
    transform: "translate(-69.544 -31.002)",
    fill: "#5cac33"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartnerMedallionLg);
export default __webpack_public_path__ + "static/media/Partner-medallionLg.c72b6066b0b6b9e4b531daabe048062c.svg";
export { ForwardRef as ReactComponent };